import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SiteService } from '@app-services/site.service';
import { TimeSlot, CheckTimeSlot } from '@app-models/site';
import { MatListOption } from '@angular/material/list';

@Component({
  selector: 'app-timeslot-dialog',
  templateUrl: './timeslot-dialog.component.html',
  styleUrls: ['./timeslot-dialog.component.scss']
})
export class TimeslotDialogComponent implements OnInit {

  slots: TimeSlot[];
  checkSlots: CheckTimeSlot[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TimeSlot[],
    private ss: SiteService,
  ) {
    if (data === undefined) {
      this.slots = [];
    } else {
      this.slots = [...data];
    }
    this.checkSlots = this.ss.getAllCheckTimeSlots();
    for (const slot of this.slots) {
      const idx = this.checkSlots.findIndex((cslot: TimeSlot) => slot.key === cslot.key);
      if (idx !== -1) {
        this.checkSlots[idx].check = true;
      }
    }
  }

  ngOnInit(): void {

  }

  selectionChange(option: MatListOption) {
    const changedSlot: TimeSlot = option.value;
    const idx = this.slots.findIndex((slot: TimeSlot) => slot.key === changedSlot.key);
    if (option.selected) {
      if (idx !== -1) {
        console.warn('Error! Slot is already existed!');
      }
      this.slots.push({
        key: changedSlot.key,
        startHour: changedSlot.startHour,
        startMin: changedSlot.startMin,
        endHour: changedSlot.endHour,
        endMin: changedSlot.endMin,
      });
    } else {
      if (idx === -1) {
        console.warn('Error! Nothing to remove');
        return;
      }
      this.slots.splice(idx, 1);
    }
  }

  formatSlot(slot: TimeSlot): string {
    return slot.key;
  }
}
